import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import ProductImageSlider from './ProductImageSlider';

import img1 from '../assets/products/1.jpg';
import img2 from '../assets/products/2.jpg';
import img3 from '../assets/products/3.jpg';
import img4 from '../assets/products/4.jpg';
import img5 from '../assets/products/Mockup.jpg';

const productImages = [img1, img2, img3, img4, img5];

export default function ProductSection() {
  return (
    <Box id="product-section" sx={{
      minHeight: '100vh',
      // Constrain to content width and align with header padding
      width: '100%',
      maxWidth: '1900px',
      bgcolor: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      py: { xs: 1, md: 4, lg: 9 },
      // Match HeaderSection inner container horizontal padding
      px: { xs: 2.5, sm: 3, md: 3, lg: 15 },
      mx: 'auto',
    }}>
      <Paper elevation={0} sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: { xs: 6, md: 10, lg: 2 },
        
        bgcolor: '#fff',
        // Remove internal paddings; rely on outer container gutters
        px: 0,
        py: 0,
        gap: { xs: 3, md: 6, lg: 1 },
        minHeight: { xs: 'auto', md: '75vh' },
        maxWidth: 1900,
        width: '100%',
      }}>
        {/* Product Images Slider */}
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: 320, maxWidth: 800, width: '100%', py: { xs: 2, md: 0 } }}>
          <ProductImageSlider images={productImages} />
        </Box>
        {/* Product Info */}
        <Box sx={{ flex: 2, minWidth: 320, maxWidth: 1200, pl: { md: 6, lg: 10 } }}>
          <Typography sx={{ fontWeight: 400, fontSize: { xs: 26, md: 38, lg: 74 }, mb: 2, lineHeight: 1.1 }}>
            Ixoria <Box component="span" sx={{ fontWeight: 500, display: 'inline' }}>Anti-Acne Face Mask</Box>
          </Typography>
          <Typography sx={{ mb: 2, fontWeight: 300, fontSize: { xs: 16, md: 20, lg: 29 }, lineHeight: 1.35, textAlign: 'justify' }}>
            First launched in 2022 as a traditional face pack, this was the product that put Ixoria on the map. <Box component="span" sx={{ fontWeight: 450, display: 'inline' }}>After wide acceptance online</Box>, it was refined into a smooth, <Box component="span" sx={{ fontWeight: 450, display: 'inline' }}>ready-to-use mask</Box> – designed for effortless application without compromising on purity or performance.
          </Typography>
          <Typography sx={{ mb: 2, fontWeight: 300, fontSize: { xs: 16, md: 20, lg: 29 }, lineHeight: 1.35, textAlign: 'justify' }}>
            Formulated with <Box component="span" sx={{ fontWeight: 450, display: 'inline' }}>clinically supported Ayurvedic herbs</Box> like Glycyrrhiza glabra, Prunus cerasoides, Mesua ferrea, Pterocarpus santalinus, Rubia cordifolia, and Symplocos racemosa, each selected for its proven benefits in calming acne, reducing inflammation, and restoring skin balance.
          </Typography>
          <Typography sx={{ mb: 4, fontWeight: 300, fontSize: { xs: 16, md: 20, lg: 29 }, lineHeight: 1.35, textAlign: 'justify' }}>
            Certified with <Box component="span" sx={{ fontWeight: 450, display: 'inline' }}>Cosmetic License, GMP, ISO, COA, and MSDS</Box>—a blend of tradition, science, and trust.
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 2, sm: 1.5, md: 2.5 }, mt: 5, justifyContent: 'flex-end', alignItems: { xs: 'stretch', sm: 'center' }, flexWrap: { xs: 'nowrap', sm: 'nowrap' } }}>
            <Button 
              component={Link}
              to="/order"
              variant="contained" 
              color="primary" 
              disableElevation sx={{
              // Compact responsive sizing to avoid text wrapping at narrow widths
              fontSize: { xs: 14, sm: 15, md: 18, lg: 20 },
              fontWeight: 400,
              borderRadius: 999,
              px: { xs: 2.5, sm: 3, md: 6, lg: 12 },
              py: { xs: 1, sm: 1.15, md: 1.6, lg: 1 },
              minWidth: { xs: 'auto', sm: 180, md: 210 },
              width: { xs: '100%', sm: 'auto' },
              textTransform: 'none',
              textDecoration: 'none',
              boxShadow: 0,
              whiteSpace: 'nowrap',
            }}>
              Order your piece
            </Button>
            <Button 
              variant="contained" 
              component="a"
              href="https://www.amazon.in/Ixoria-Anti-Acne-Herbal-Complexion-Enhancement/dp/B0C78FX159"
              target="_blank"
              rel="noopener noreferrer"
              disableElevation sx={{
              bgcolor: '#ededed',
              color: '#111',
              fontWeight: 400,
              fontSize: { xs: 14, sm: 15, md: 18, lg: 20 },
              borderRadius: 999,
              px: { xs: 2.5, sm: 3, md: 6, lg: 12 },
              py: { xs: 1, sm: 1.15, md: 1.6, lg: 1 },
              boxShadow: 0,
              textTransform: 'none',
              minWidth: { xs: 'auto', sm: 180, md: 210 },
              width: { xs: '100%', sm: 'auto' },
              '&:hover': { bgcolor: '#e0e0e0' },
              whiteSpace: 'nowrap',
            }}>
              Explore on <Box component="span" sx={{ fontWeight: 500, color: '#000', ml: 1, fontSize: 'inherit', display: 'inline' }}>amazon.in</Box>
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}
